<template>
  <b-card>
    <b-row>
      <b-col
        v-if="!dataLoad"
        cols="12"
        md="6"
      >
        <b-form-group
          label="Search"
        >
          <SearchInputAction
            :data-load="dataLoad"
            :view-search-input="true"
            :get-all-data="getAllSalaryData"
          /></b-form-group></b-col>
      <b-col
        v-if="!dataLoad"
        cols="12"
        md="6"
      ><SelectOffice
        :show-select-office="true"
      /></b-col>

    </b-row>
    <div
      v-if="dataLoad"
      class=" text-center my-2"
    >
      <b-spinner
        type="grow"
        label="Loading..."
      />
    </div>

    <b-table
      v-else
      :fields="fields"
      :items="columns"
      class="auto-table"
    >
      <template #cell(photo)="data">
        <div
          class="d-flex py-1 pl-1"
          style="max-width: 300px"
        >
          <b-avatar
            variant="info"
            :src="data.item.photo"
            size="4rem"
          />
          <div
            class="d-flex flex-column justify-content-start align-items-start mx-1 cursor-pointer"
          >
            <p class="font-weight-bold m-0">
              {{ data.item.name }}
            </p>
            <p class="text-muted ">
              {{ data.item.email }}
            </p>
          </div>
        </div>
      </template>

      <template #cell(salary)="data">
        <div
          class="d-flex align-items-center gap-1"
          style="max-width: 300px"
        >

          <!-- VIEW MODE -->
          <template v-if="editingRowId !== data.item.id">
            <span>{{ data.item.salary }}</span>

            <feather-icon
              icon="EditIcon"
              color="primary"
              class="cursor-pointer ml-1"
              @click="startEditSalary(data.item)"
            />
          </template>

          <!-- EDIT MODE -->
          <template v-else>
            <b-form-input
              v-model="editedSalary"
              type="number"
              size="sm"
              class="mr-1"
              style="max-width: 120px"
            />

            <b-button
              size="sm"
              variant="success"
              :disabled="saveLoading"
              @click="saveSalary(data.item)"
            >
              Save
            </b-button>

            <b-button
              size="sm"
              variant="outline-secondary"
              class="ml-1"
              @click="cancelEdit"
            >
              Cancel
            </b-button>
          </template>

        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'
import SearchInputAction from '@/components/general-table/actions/SearchInputAction.vue'
import SelectOffice from '@/components/general-table/filter-by/fixed-filter/SelectOffice.vue'
import buildParams from '@/components/general-table/specific-utils/buildParams'
//
export default {
  components: {
    SearchInputAction,
    SelectOffice,
  },
  data() {
    return {
      apiUrl: 'user-with-salary',
      dataLoad: false,
      columns: [],
      fields: [
        { key: 'photo', label: 'User' },
        { key: 'office', label: 'Office' },
        { key: 'salary', label: 'Salary' },
      ],
      editingRowId: null, // 👈 which row is in edit mode
      editedSalary: null, // 👈 temp salary value
      saveLoading: false,
    }
  },
  watch: {
    '$route.query': {
      handler() {
        this.getAllSalaryData()
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    this.getAllSalaryData()
  },
  methods: {
    async getAllSalaryData() {
      this.dataLoad = true

      try {
        const params = buildParams(this, 0)

        const response = await axios.get(this.apiUrl, { params })
        if (response.status === 200) {
          const responseData = decryptData(response.data.payload)?.data?.users
          this.columns = responseData
        }
      } catch (error) {
        if (error.response.status === 500) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Server Error',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      } finally {
        this.dataLoad = false
      }
    },
    startEditSalary(item) {
      this.editingRowId = item.id
      this.editedSalary = item.salary
    },

    cancelEdit() {
      this.editingRowId = null
      this.editedSalary = null
    },

    async saveSalary(item) {
      this.saveLoading = true

      try {
        await axios.put(`/user/${item.id}/salary`, {
          salary: this.editedSalary,
        })

        // eslint-disable-next-line no-param-reassign
        item.salary = this.editedSalary

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Salary Updated',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        this.cancelEdit()
      } catch (error) {
        decryptData(error.response?.data?.payload)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Update Failed',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.saveLoading = false
      }
    },
  },
}
</script>

<style>
.auto-table th,
.auto-table td {
  white-space: nowrap;
  overflow: hidden;
  text-align: start !important;
}
</style>
